module.exports = __webpack_public_path__ + "img/data_cai.5935185c.png";